import _ from 'underscore';
import ObjectUtil from '@component/common/src/util/ObjectUtil';

const Marionette = require('backbone.marionette');

const Router = require('./src/PageRouter');

require('@core/vendor/radio.shim');

// Load polyfills
require('./src/polyfills')();

const app = new Marionette.Application();
const router = new Router();
app.router = router;

router.on('app:init-feature', (obj) => {
  app.channel.trigger('app:init-feature', obj);
});

router.on('load:delayed:scripts', (obj) => {
  app.channel.trigger('load:delayed:scripts', obj);
});

app.meta = {
  analytics: {
    coremetrics: {
      categoryID: 'my-re-xx-xx.index',
    },
  },
  properties: {},
  context: {},
};

/**
 * This method used for getting the meta property object/value.
 * Usage:
 *
 * 1) PageApp.getMeta('context') // Returns meta.context object.
 * 2) PageApp.getMeta('context.searchTerm') // Returns 'jeans' as value.
 * 3) PageApp.getMeta('pageType.subType.autoComplete')
 *                  OR
 *    PageApp.getMeta('pageType.subType').autoComplete // Returns true/false as value.
 * 4) Invalid hierarchy or key will result in empty string.
 */
app.getMeta = (key) => {
  const meta = ObjectUtil.getChildProperty(app.meta, key);
  return _.isUndefined(meta) ? '' : meta;
};

module.exports = app;
